// Tokens de la direccion visual A "Marino" (elegida el 2026-09-30).
// Fuente de verdad: DESIGN.md y docs/ux/direccion-visual.html.
// Contraste AA verificado con contrast.js el 2026-09-30.

// Colores del logo: solo marca (fondos, detalles). No se usan para texto.
export const brand = {
	marino: '#184878',
	celeste: '#3492D8',
	verde: '#79C24A',
	// Derivado del marino (no sale del logo): extremo oscuro del degradado del panel de marca del Login.
	marinoOscuro: '#0E2C4D'
};

export const light = {
	background: '#F4F7FB',
	surface: '#FFFFFF',
	border: '#D5DEE9',
	text: '#142233',
	textSecondary: '#4F5F73',
	primary: '#184878',
	onPrimary: '#FFFFFF',
	secondary: '#4F5F73',
	onSecondary: '#FFFFFF',
	info: '#1F6FB2',
	onInfo: '#FFFFFF',
	success: '#2E7D32',
	onSuccess: '#FFFFFF',
	warning: '#9A5B00',
	onWarning: '#FFFFFF',
	error: '#B3261E',
	onError: '#FFFFFF',
	// Fondos suaves para chips y estados
	soft: {
		success: '#EDF6ED',
		warning: '#FBEFD9',
		error: '#FBE4E2',
		primary: '#E3ECF7'
	},
	// Menu lateral (lo usa la fase W0)
	side: '#FFFFFF',
	// Tooltip
	tooltipBg: '#142233',
	tooltipText: '#FFFFFF'
};

export const dark = {
	background: '#0E1824',
	surface: '#16222F',
	border: '#2A3A4C',
	text: '#E6EDF5',
	textSecondary: '#A3B2C4',
	primary: '#9CC3EE',
	onPrimary: '#0E1824',
	secondary: '#A3B2C4',
	onSecondary: '#0E1824',
	info: '#9CC3EE',
	onInfo: '#0E1824',
	success: '#8BD06A',
	onSuccess: '#0E1824',
	warning: '#F0B45A',
	onWarning: '#0E1824',
	error: '#F28B82',
	onError: '#0E1824',
	soft: {
		success: '#1D3320',
		warning: '#3A2C14',
		error: '#3D1F1D',
		primary: '#1F3550'
	},
	side: '#121D2A',
	tooltipBg: '#E6EDF5',
	tooltipText: '#0E1824'
};

// Forma: la identidad actual se conserva (botones 20, campos 30, tarjetas 30, dialogos 40).
export const radius = {
	small: 12, // menus, popovers, tooltips, alertas
	button: 20,
	field: 30,
	card: 30,
	dialog: 40
};

// Lato la fuerza index.css con !important; se declara aqui para que el theme sea coherente.
export const fontFamily = '"Lato", "Helvetica", "Arial", sans-serif';

export const tokens = { light, dark, brand, radius, fontFamily };
